export default __webpack_public_path__ + "static/media/service-thumb-concrete-steps.afe9fcee.jpg";